/* istanbul ignore file */
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { ADPResourceService, ADPComponentsModule } from 'digital-core';

import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ModalWindowComponent } from 'src/app/shared/components/modal-window/modal-window.component';

@Component({
    selector: 'services-requests-modal-window',
    templateUrl: './services-requests-modal-window.component.html',
    styleUrls: ['./services-requests-modal-window.component.scss'],
    imports: [ModalWindowComponent, MatIconButton, MatDialogClose, MatIcon, ADPComponentsModule]
})
export class ServicesRequestsModalWindowComponent {

  constructor(
    public dialogRef: MatDialogRef<ServicesRequestsModalWindowComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    private resourceService: ADPResourceService,
  ) { }

  getLabel(key: string) {
    return this.resourceService.getViewLabel(key);
  }

}
